<template>
  <span :style="styleObj" v-show="isSaving" class="save-text flash">Saving...</span>
</template>
<script>
  import { mapState } from 'vuex';
  export default {
    name: 'SaveText',

    props: {
      styleObj: {
        type: Object,
        default: () => {},
      },
    },

    computed: {
      ...mapState('editMode', ['isSaving']),
    },
  };
</script>
<style lang="scss">
  .flash {
    animation: myfirst 1.5s;
    -moz-animation: myfirst 1.5s infinite; /* Firefox */
    -webkit-animation: myfirst 1.5s infinite; /* Safari and Chrome */
  }

  @-moz-keyframes myfirst /* Firefox */ {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }

  @-webkit-keyframes myfirst /* Safari and Chrome */ {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }
</style>
